'use client';

import { Tabs } from '@/components/atoms/Tabs/Tabs';
import SubTabs from '@/components/atoms/Tabs/SubBoxTabs';
import { useState } from 'react';
import cx from 'classnames';
import { TABS, SUB_TABS } from './config';
import { sendGTM, GTMEventKey, CustomEventName } from '@/utils/gtm';

const ForexListTabs = ({
  children,
  tabStyle,
  isSearch,
  clearSearch
}: {
  children: Function;
  tabStyle?: string;
  isSearch?: boolean;
  clearSearch?: () => void;
}) => {
  const [tab, setTab] = useState(TABS[0].value);
  const [subTab, setSubTab] = useState(SUB_TABS[0].value);

  const onClickTab = (index: number) => {
    sendGTM({
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAB,
      [GTMEventKey.SECTION]: '%p_看看匯率',
      [GTMEventKey.CLICK_ITEM]: TABS[index].value
    });
    setTab(TABS[index].value);
  };

  const onClickSubTab = (index: number) => {
    sendGTM({
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_TAG,
      [GTMEventKey.SECTION]: '%p_看看匯率',
      [GTMEventKey.CLICK_ITEM]: SUB_TABS[index].value
    });
    clearSearch?.();
    setSubTab(SUB_TABS[index].value);
  };

  // 當搜尋框有字時，需要切換到全球的tab
  const active = isSearch ? 4 : undefined;

  return (
    <div className='mt-4 bg-white lg:pl-5'>
      <Tabs tabs={TABS} onClick={onClickTab} onHover={onClickTab} />
      <div className={cx(tabStyle)}>
        <SubTabs tabs={SUB_TABS} onClick={onClickSubTab} active={active} />
      </div>
      {children?.({ tab, subTab })}
    </div>
  );
};

export default ForexListTabs;
